const PaidInclusionExistingStatesUpdate = ({
    message = '',
    replaceText = '',
    replaceUrl = '',
}) => ({
    message: String(message),
    replaceText: String(replaceText),
    replaceUrl: String(replaceUrl),
});

export default PaidInclusionExistingStatesUpdate;
